import {
  buildAdaptiveSingleFilterSection,
  buildMultiListFilterSection,
} from "../../shared/buildListFilterSections";

export function countActiveReportFilters({
  filters,
  showMachines = true,
  showShifts = true,
  showModel = true,
  showTransFilters = false,
}) {
  const {
    machineIds = [],
    shiftId,
    transFromStatus,
    transToStatus,
    transModelId,
  } = filters;

  return (
    (showMachines ? machineIds.length : 0) +
    (showShifts && shiftId ? 1 : 0) +
    (showTransFilters && transFromStatus ? 1 : 0) +
    (showTransFilters && transToStatus ? 1 : 0) +
    (showTransFilters && showModel && transModelId ? 1 : 0)
  );
}

export function buildReportFilterSections({
  filters,
  machines = [],
  shifts = [],
  deviceModels = [],
  showTransFilters = false,
  showMachines = true,
  showShifts = true,
  showModel = true,
  columns = null,
  visibleColumns = [],
  onToggleColumn,
  onResetColumns,
  columnSections = [],
}) {
  const {
    machineIds,
    setMachineIds,
    shiftId,
    setShiftId,
    transModelId,
    setTransModelId,
  } = filters;

  const sections = [];

  const addColumnSection = ({
    id,
    title = "Görüntülenen Sütunlar",
    cols,
    visible,
    onToggle,
    onReset,
    defaultOpen = true,
  }) => {
    if (!cols?.length || !onToggle) return;
    sections.push({
      id,
      type: "columns",
      title,
      columns: cols,
      visibleColumns: visible,
      onToggle,
      onReset,
      defaultOpen,
    });
  };

  if (columnSections?.length) {
    columnSections.forEach(addColumnSection);
  } else if (columns?.length && onToggleColumn) {
    addColumnSection({
      id: "columns",
      cols: columns,
      visible: visibleColumns,
      onToggle: onToggleColumn,
      onReset: onResetColumns,
    });
  }

  if (showShifts) {
    sections.push(
      buildAdaptiveSingleFilterSection({
        id: "shift",
        title: "Vardiya",
        value: shiftId,
        onChange: (v) => setShiftId(String(v ?? "")),
        options: [
          { value: "", label: "Tüm Vardiyalar" },
          ...shifts.map((s) => ({
            value: String(s._id),
            label: s.name || "—",
          })),
        ],
        allValue: "",
        allLabel: "Tüm Vardiyalar",
        defaultOpen: true,
      }),
    );
  }

  if (showMachines && machines.length > 0) {
    sections.push(
      buildMultiListFilterSection({
        id: "machines",
        title: "Makine",
        selectedIds: machineIds,
        onChange: setMachineIds,
        options: machines.map((m) => ({
          value: String(m._id),
          label: m.name || "—",
          keywords: [m.code, m.name].filter(Boolean),
        })),
        showAllOption: true,
        allLabel: "Tümü",
        searchPlaceholder: "Makine ara…",
        defaultOpen: true,
      }),
    );
  }

  if (showTransFilters && showModel) {
    sections.push(
      buildAdaptiveSingleFilterSection({
        id: "model",
        title: "Model",
        value: transModelId,
        onChange: (v) => setTransModelId(String(v ?? "")),
        options: [
          { value: "", label: "Tüm Modeller" },
          ...deviceModels.map((m) => ({
            value: String(m._id),
            label: m.name || "—",
            keywords: [m.code, m.name].filter(Boolean),
          })),
        ],
        allValue: "",
        allLabel: "Tüm Modeller",
        searchPlaceholder: "Model ara…",
        defaultOpen: false,
      }),
    );
  }

  return sections;
}
